/**
 * Ensure a filled-form download has a `.pdf` extension for preview routing.
 *
 * The BE often returns `filename` as the template display name (e.g. "Aetna form")
 * without an extension. `ChatDocumentPreview` / `getDocumentType` key only off the
 * extension, so a bare title routes to "Preview not available for this file type"
 * even though the bytes are always a PDF.
 */
export function ensurePdfFilename(filename: string | null | undefined): string {
  const trimmed = filename?.trim() ?? '';
  if (!trimmed) return 'filled_form.pdf';
  return /\.pdf$/i.test(trimmed) ? trimmed : `${trimmed}.pdf`;
}
